/* ============================================================
   sc-giveaway.js — Countdown + Entry Form
   ============================================================ */

/* ── Countdown Timer ── */
(function initCountdown() {
  const wrap = document.querySelector('[data-sc-giveaway-countdown]');
  if (!wrap) return;

  const endDate = new Date(wrap.dataset.end);
  const daysEl  = wrap.querySelector('[data-days]');
  const hoursEl = wrap.querySelector('[data-hours]');
  const minsEl  = wrap.querySelector('[data-mins]');
  const secsEl  = wrap.querySelector('[data-secs]');

  function tick() {
    const diff = endDate - Date.now();

    if (diff <= 0) {
      clearInterval(timer);
      wrap.innerHTML = '<p style="font-family:\'Courier New\',monospace;font-size:1rem;letter-spacing:.25em;color:#00d4ff;text-transform:uppercase;">ENTRIES CLOSED</p>';
      return;
    }

    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000)  / 60000);
    const s = Math.floor((diff % 60000)    / 1000);

    daysEl.textContent  = String(d).padStart(2, '0');
    hoursEl.textContent = String(h).padStart(2, '0');
    minsEl.textContent  = String(m).padStart(2, '0');
    secsEl.textContent  = String(s).padStart(2, '0');
  }

  tick();
  const timer = setInterval(tick, 1000);
})();

/* ── Entry Form ── */
(function initForm() {
  const form    = document.querySelector('[data-sc-giveaway-form]');
  if (!form) return;

  const webhook   = form.dataset.webhook || '';
  const successEl = document.querySelector('.sc-giveaway__success');
  const errorEl   = form.querySelector('.sc-giveaway__form-error');
  const submitBtn = form.querySelector('.sc-giveaway__submit');
  const submitTxt = submitBtn.querySelector('.sc-giveaway__submit-text');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorEl.textContent = '';

    const name  = form.querySelector('[name="name"]').value.trim();
    const email = form.querySelector('[name="email"]').value.trim();
    const phone = form.querySelector('[name="phone"]').value.trim();
    const ig    = form.querySelector('[name="instagram"]').value.trim();
    const ref   = form.querySelector('[name="referred_by"]').value.trim();

    /* Validation */
    if (!name || !email || !ig) {
      errorEl.textContent = 'NAME, EMAIL, AND INSTAGRAM HANDLE ARE REQUIRED.';
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'ENTER A VALID EMAIL ADDRESS.';
      return;
    }

    if (!webhook) {
      errorEl.textContent = 'WEBHOOK NOT CONFIGURED. DM @STAGEDCUSTOMS TO ENTER MANUALLY.';
      return;
    }

    submitBtn.disabled = true;
    submitTxt.textContent = 'SUBMITTING...';

    try {
      const res = await fetch(webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'giveaway_entry',
          name,
          email,
          phone: phone || 'Not provided',
          instagram: ig,
          referred_by: ref || 'None'
        })
      });

      if (!res.ok) throw new Error('Server error ' + res.status);

      form.style.display = 'none';
      if (successEl) successEl.style.display = 'block';

    } catch (err) {
      console.error(err);
      errorEl.textContent = "SOMETHING WENT WRONG. DM US @STAGEDCUSTOMS TO ENTER MANUALLY.";
      submitBtn.disabled = false;
      submitTxt.textContent = 'ENTER THE GIVEAWAY';
    }
  });
})();

/* ── Theme editor re-init ── */
document.addEventListener('shopify:section:load', function () {
  // Re-run countdown and form init when section reloads in editor
  const event = new Event('DOMContentLoaded');
  document.dispatchEvent(event);
});
